import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n';

// Footer delgado: copyright + enlaces legales. Reusa el sistema legal (/legal/:slug).
export default function Footer() {
  const t = useT();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/20 mt-8 py-3 px-4 text-xs text-slate-500 dark:text-slate-400">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-2">
        <span>© {year} SapiensDoc. {t('footer.rights')}</span>
        <nav className="flex items-center gap-4">
          <Link to="/legal/terms" className="hover:text-sky-500 hover:underline transition-colors">
            {t('footer.terms')}
          </Link>
          <Link to="/legal/privacy" className="hover:text-sky-500 hover:underline transition-colors">
            {t('footer.privacy')}
          </Link>
        </nav>
      </div>
    </footer>
  );
}
